import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * Pulls home_latitude / home_longitude from server settings into ThemeContext
 * so sunrise/sunset auto-detection uses the correct location.
 *
 * Runs once after auth + every 30 minutes.
 */
export default function ThemeSyncer() {
  const { api, user } = useAuth();
  const { setHomeLocation } = useTheme();

  useEffect(() => {
    if (!user || !api) return;
    let cancelled = false;
    const sync = async () => {
      try {
        const res = await api.get('/settings');
        const lat = parseFloat(res.data?.home_latitude || 0);
        const lng = parseFloat(res.data?.home_longitude || 0);
        if (!cancelled && (lat || lng)) setHomeLocation(lat, lng);
      } catch (_) { /* ignore */ }
    };
    sync();
    const t = setInterval(sync, 30 * 60 * 1000);
    return () => { cancelled = true; clearInterval(t); };
  }, [api, user, setHomeLocation]);

  return null;
}
